import type { IEventTypeFilterOption } from './type';

// Event type color config
export const IN_DEV_EVENT_TYPES: IEventTypeFilterOption[] = [
  { key: 'gr_meeting', label: 'GR Meeting', color: '#cbc5f9' },
  { key: 'checkin_meeting', label: 'Check-in Meeting', color: '#debbed' },
  { key: 'to_be_launched', label: 'To be Launched', color: '#a7c3fa' },
  { key: 'milestone', label: 'Milestone', color: '#e0e1e5' },
];

export const LIVE_EVENT_TYPES: IEventTypeFilterOption[] = [
  { key: 'major_updates', label: 'Major Updates Event', color: '#debbed' },
  { key: 'event', label: 'Event', color: '#e0e1e4' },
];

export const EVENT_TYPE_BG_COLORS: Record<string, string> = {
  gr_meeting: '#f2f1fe',
  checkin_meeting: '#f7eefb',
  to_be_launched: '#e6f1ff',
  milestone: '#f9f9fa',
  major_updates: '#f7eefb',
  event: '#f9f9fa',
};

export const EVENT_TYPE_BORDER_COLORS: Record<string, string> = {
  gr_meeting: '#f2f1fe',
  checkin_meeting: '#f7eefb',
  to_be_launched: '#e6f1ff',
  milestone: '#f9f9fa',
  major_updates: '#f7eefb',
  event: '#f9f9fa',
};

export const MONTH_LABELS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

// 日历卡片尺寸，不同的尺寸对应不同的宽度
export enum CalendarCardSize {
  // 超小
  XS = 1,
  // 小
  S = 2,
  // 中
  M = 3,
  // 大
  L = 4,
  // 超大
  XL = 5,
}

export enum CalendarCardSizeFull {
  XXS = 1,
  XS = 2,
  S = 3,
  M = 4,
  L = 5,
  XL = 6,
  XXL = 7,
  XXXL = 8,
  XXXXL = 9,
  XXXXXL = 10,
  XXXXXXL = 11,
  XXXXXXXL = 12,
  XXXXXXXXL = 13,
  XXXXXXXXXL = 14,
}

// 日历卡片无数据时的宽度
export const CALENDAR_EMPTY_CARD_WIDTH = 100;

// 日历卡片最大展示行数，超过该行数的日历卡片在折叠状态下 就会折叠，展开状态下则展示
export const MAX_ROW_NUM = 4;

export const STEPPER_DATE_FORMAT_MAP = {
  month: 'YYYY.MM',
  quarter: 'YYYY.Q',
  year: 'YYYY',
};

// 日历卡片宽度映射--全屏
export const CALENDAR_CARD_WIDTH_MAPPING_FULL: {
  [key in CalendarCardSizeFull]: number;
} = {
  [CalendarCardSizeFull.XXS]: 52,
  [CalendarCardSizeFull.XS]: 56,
  [CalendarCardSizeFull.S]: 62,
  [CalendarCardSizeFull.M]: 68,
  [CalendarCardSizeFull.L]: 76,
  [CalendarCardSizeFull.XL]: 82,
  [CalendarCardSizeFull.XXL]: 86,
  [CalendarCardSizeFull.XXXL]: 96,
  [CalendarCardSizeFull.XXXXL]: 110,
  [CalendarCardSizeFull.XXXXXL]: 120,
  [CalendarCardSizeFull.XXXXXXL]: 140,
  [CalendarCardSizeFull.XXXXXXXL]: 150,
  [CalendarCardSizeFull.XXXXXXXXL]: 160,
  [CalendarCardSizeFull.XXXXXXXXXL]: 166,
};

// 日历卡片宽度映射--非全屏
export const CALENDAR_CARD_WIDTH_MAPPING: {
  [key in CalendarCardSize]: number;
} = {
  [CalendarCardSize.XS]: 100,
  [CalendarCardSize.S]: 110,
  [CalendarCardSize.M]: 120,
  [CalendarCardSize.L]: 140,
  [CalendarCardSize.XL]: 160,
};

// 默认日历卡片尺寸
export const DEFAULT_CALENDAR_CARD_SIZE = CalendarCardSize.M;
// 最小日历卡片尺寸
export const MIN_CALENDAR_CARD_SIZE = CalendarCardSize.XS;
// 最大日历卡片尺寸
export const MAX_CALENDAR_CARD_SIZE = CalendarCardSize.XL;
// 日历卡片尺寸集合
export const CALENDAR_CARD_SIZES = [
  CalendarCardSize.XS,
  CalendarCardSize.S,
  CalendarCardSize.M,
  CalendarCardSize.L,
  CalendarCardSize.XL,
];

export const CALENDAR_CARD_SIZES_FULL = [
  CalendarCardSizeFull.XXS,
  CalendarCardSizeFull.XS,
  CalendarCardSizeFull.S,
  CalendarCardSizeFull.M,
  CalendarCardSizeFull.L,
  CalendarCardSizeFull.XL,
  CalendarCardSizeFull.XXL,
  CalendarCardSizeFull.XXXL,
  CalendarCardSizeFull.XXXXL,
  CalendarCardSizeFull.XXXXXL,
  CalendarCardSizeFull.XXXXXXL,
  CalendarCardSizeFull.XXXXXXXL,
  CalendarCardSizeFull.XXXXXXXXL,
  CalendarCardSizeFull.XXXXXXXXXL,
];

